import { render, staticRenderFns } from "./tabCommon.vue?vue&type=template&id=dbe4b022&scoped=true&"
import script from "./tabCommon.vue?vue&type=script&lang=js&"
export * from "./tabCommon.vue?vue&type=script&lang=js&"
import style0 from "./tabCommon.vue?vue&type=style&index=0&id=dbe4b022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe4b022",
  null
  
)

export default component.exports